export const LANG_EN_NAME = "tr";

export const LANG_EN_TRANS = {
  /* Select Language */
  lang_az: "Azerbaycanca",
  lang_en: "İngilizce",
  lang_tr: "Türkçe",
  lang_ru: "Rusça",
  lang_fa: "Farsça",
  Turkey: "Türkiye",

  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",

  /********** BELGE TÜRLERİ **********/
  /* SATINALMA MODULU */
  PURCHASE_DISPATCH: "Satınalma İrsaliyesi",
  PURCHASE_RETURN_DISPATCH: "Satınalma İade İrsaliyesi",
  PURCHASE_CONSIGNMENT_DISPATCH: "Konsinye Giriş İrsaliyesi",
  PURCHASE_CONSIGNMENT_RETURN_DISPATCH: "Konsinye Giriş İade İrsaliyesi",
  PURCHASE_RETURN_INVOICE: "Satınalma İade Faturası",
  PURCHASE_INVOICE: "Satınalma Faturası",
  PURCHASE_RECEIVE_SERVICE_INVOICE: "Alınan Hizmet Faturası",
  PURCHASE_RECEIVE_PROFORMA_INVOICE: "Alınan Proforma Faturası",
  PURCHASE_PRICE_DIFF_INVOICE: "Satınalma Fiyat Farkı Faturası",
  PURCHASE_PRODUCER_INVOICE: "Muhtahsil Makbuzu",
  PURCHASE_SERVICE_CARD: "Alınan Hizmet Kartları",

  /*SATIŞ MODULU */
  SALES_INVOICE: "Satış Faturaları",
  SALES_SERVICE_CARD: "Verilen Hizmet Kartları",
  SALES_RETAIL_INVOICE: "Perakende Satış Faturası",
  SALES_RETAIL_RETURN_INVOICE: "Perakende Satış İade Faturası",
  SALES_WHOLESALE_INVOICE: "Toptan Satış Faturası",
  SALES_WHOLESALE_RETURN_INVOICE: "Toptan Satış İade Faturası",
  SALES_GIVEN_SERVICE_INVOICE: "Verilen Hizmet Faturası",
  SALES_GIVEN_PROFORMA_INVOICE: "Verilen Proforma Faturası",
  SALES_PRICE_DIFF_INVOICE: "Satış Fiyat Farkı Faturası",
  SALES_DISPATCH: "Satış İrsaliyeleri",
  SALES_RETAIL_DISPATCH: "Perakende Satış İrsaliyesi",
  SALES_RETAIL_RETURN_DISPATCH: "Perakende Satış İade İrsaliyesi",
  SALES_WHOLESALE_DISPATCH: "Toptan Satış İrsaliyesi",
  SALES_WHOLESALE_RETURN_DISPATCH: "Toptan Satış İade İrsaliyesi",
  SALES_CONSIGNMENT_DISPATCH: "Konsinye Çıkış İrsaliyesi",
  SALES_CONSIGNMENT_RETURN_DISPATCH: "Konsinye Çıkış İade İrsaliyesi",

  /* CARİ HESAP FİŞLERİ */
  CURR_ACCOUNT_REMITTANCE_RECEIPT: "Virman Fişi",
  CURR_ACCOUNT_EXCHANGE_DIFFERENCE_RECEIPT: "Kur Farkı Fişi",
  CURR_ACCOUNT_CASH_COLLECTION: "Nakit Tahsilat",
  CURR_ACCOUNT_CASH_PAYMENT: "Nakit Ödeme",
  CURR_ACCOUNT_DEBIT_NOTE: "Borç Dekontu",
  CURR_ACCOUNT_CREDIT_NOTE: "Alacak Dekontu",

  /* FIYAT DEĞİŞİM FİŞLERİ */
  RETAIL_PURCHASE_RETAIL_SALES_PRICE_CHANGE_RECEIPT:
    "Alış / Satış Fiyat Değişim Fişi",
  RETAIL_PURCHASE_PRICE_CHANGE_RECEIPT: "Alış Fiyat Değişim Fişi",
  RETAIL_SALES_PRICE_CHANGE_RECEIPT: "Satış Fiyat Değişim Fişi",

  /* MALZEME YÖNETİM FİŞLERİ */
  MATERIAL_SCRAP_RECEIPT: "Fire Fişi",
  MATERIAL_USAGE_RECEIPT: "Sarf Fişi",
  MATERIAL_SHORTAGE_STOCK_RECEIPT: "Sayım Eksiği Fişi",
  MATERIAL_EXCESS_STOCK_RECEIPT: "Sayım Fazlası Fişi",
  MATERIAL_WAREHOUSE_OUTPUT_RECEIPT: "Depo Çıkış Fişi",
  MATERIAL_WAREHOUSE_INPUT_RECEIPT: "Depo Giriş Fişi",
  MATERIAL_WAREHOUSE_TRANSFER_RECEIPT: "Depolar Arası Transfer Fişi",

  /* Kasa Fişleri */
  CASH_ACCOUNT_OPENING_RECEIPT_DEBIT: "Açılış Fişi (Borç)",
  CASH_ACCOUNT_OPENING_RECEIPT_CREDIT: "Açılış Fişi (Alacak)",
  CASH_ACCOUNT_REMITTANCE_RECEIPT_DEBIT: "Virman Fişi (Borç)",
  CASH_ACCOUNT_REMITTANCE_RECEIPT_CREDIT: "Virman Fişi (Alacak)",
  CASH_ACCOUNT_EXCHANGE_DIFFERENCE_RECEIPT_DEBIT: "Kur Farkı Fişi (Borç)",
  CASH_ACCOUNT_EXCHANGE_DIFFERENCE_RECEIPT_CREDIT: "Kur Farkı Fişi (Alacak)",
  CASH_ACCOUNT_CURRENTACCOUNT_COLLECTION: "Cari Hesap Tahsilat",
  CASH_ACCOUNT_CURRENTACCOUNT_PAYMENT: "Cari Hesap Ödeme",

  /* Banka Fişleri */
  BANK_ACCOUNT_RECEIPT: "Bank Receipt",
  BANK_ACCOUNT_REMITTANCE_RECEIPT: "Virman Fişi",
  BANK_ACCOUNT_INCOMING_REMITTANCE_RECEIPT: "Gelen Havale / EFT",
  BANK_ACCOUNT_SENT_REMITTANCE_RECEIPT: "Gönderilen Havale / EFT",
  BANK_ACCOUNT_OPENING_RECEIPT: "Açılış Fişi",
  BANK_ACCOUNT_EXCHANGE_DIFFERENCE_RECEIPT: "Kur Farkı Fişi",

  /* ENUMS */
  ALL: "Tümü",
  INPUT: "Giriş",
  OUTPUT: "Çıkış",
  CREDIT_CARD: "Kredi Kartı",
  CREDIT: "Alacak",
  CREDIT_BANK: "Kredi",
  DEBIT: "Borç",
  COMMERCIAL_GOODS: "Ticari Mal",
  COMMERCIAL: "Ticari",
  PRODUCT: "Mamül",
  SEMI_PRODUCT: "Yarı mamül",
  RAW_MATERIAL: "Ham madde",
  MATERIAL: "Malzeme",
  SERVICE: "Hizmet",
  FUEL: "Akaryakıt",
  CURRENT_ACCOUNT_SELLER: "Müşteri / Satıcı",
  CURRENT_ACCOUNT: "Müşteri",
  SELLER: "Satıcı",
  MAIN_CURRENT_ACCOUNT: "Ana Cari",
  ACTIVE: "Aktif",
  PASSIVE: "Pasif",
  DISCOUNT: "İndirim",
  EXPENSE: "Masraf",
  POSITIVE_BALANCE: "+ Bakiyeler",
  NEGATIVE_BALANCE: "- Bakiyeler",
  ZERO_BALANCE: "0 Bakiyeler",
  LIST: "Listelenecek",
  NOTLIST: "Listelenmeyecek",
  PURCHASEMANAGER: "Satınalma Sorumlusu",
  SALESMANAGER: "Satış Sorumlusu",
  MATERIAL_CARD: "Malzeme Kartları",
  MATERIAL_RECEIPT: "Malzeme Yönetim Fişleri",
  CURRENT_ACCOUNT_CARD: "Cari Hesap Kartları",
  CURRENT_ACCOUNT_RECEIPT: "Cari Hesap Fişleri",
  CURRENT_ACCOUNT_RECEIPT_LINE: "Cari Hesap Fiş Satırları",
  CASH_ACCOUNT: "Kasa Kartları",
  CASH_ACCOUNT_RECEIPT: "Kasa Fişleri",
  PRICE_CHANGE_RECEIPT: "Fiyat Değişim Fişleri",
  YES_WITH_PASSWORD: "Evet (Şifreli)",
  YES: "Evet",
  NO: "Hayır",
  LOT: "Lot",
  SERIAL_NUM: "Seri No",
  NONE: "Yok",
  WEIGHTED: "Tartılı",
  COUNTLINE: "Adetli",
  PLU: "Plu",
  NOACTION: "İşlem Yapılmayacak",
  CASH: "Nakit",
  CREDITCARD: "Kredi Kartı",
  PURCHASE_AMOUNT: "Döviz Alış",
  SALES_AMOUNT: "Döviz Satış",
  EFFECTIVE_PURCHASE_AMOUNT: "Efektif Alış",
  EFFECTIVE_SALES_AMOUNT: "Efektif Satış",
  EXCHANGE_BUYING: "Döviz Alış",
  EXCHANGE_SALES: "Döviz Satış",
  EFFECTIVE_BUYING: "Efektif Alış",
  EFFECTIVE_SALES: "Efektif Satış",
  MS_SQL_SERVER: "MS SQL Server",
  TEXT_FILE: "Text File",

  /* Gün sonu e-num */
  NO_SALE: "Satış Yok",
  END_OF_DAY_GENERATE: "Gün Sonu Yapılmış",
  END_OF_DAY_NOT_GENERATE: "Gün Sonu Yapılmamış",

  /* Pos kasa e-num */
  KLRETAIL_MPOS: "KL Retail MPOS",
  NPOS: "N-POS",

  /* Fiyat değişim fişi e-num */
  DRAFT: "Onaylanmadı",
  APPROVED: "Onaylandı",
  SEMI_APPROVED: "Kısmi Onaylı",

  /* Pos kasa terazi bayrak e-num */
  CODE_WEIGHT: "Kod + Gramaj",
  CODE_QUANTITY: "Kod + Adet",
  CODE_AMOUNT: "Kod + Tutar",

  /* Müşteri kartları e-num */
  PERSONAL: "Bireysel",
  COMMERCIAL_CUSTOMER: "Kurumsal",
  OTHER: "Diğer",

  /* Zaman görevleyicisi türleri */
  KLRETAILMPOS_SEND_DATA: "KL Retail Mpos Bilgi Gönderimi",

  /* Zaman görevleyicisi işlem türlleri */
  CASH_REG_SENDATA_MATERIAL_ALL: "Pos Kasalara Malzeme Gönder (Tümü)",
  CASH_REG_SENDATA_MATERIAL_CHANGE: "Pos Kasalara Malzeme Gönder (Değişenler)",
  CASH_REG_SENDATA_CUSTOMER_ALL: "Pos Kasalara Cari Gönder (Tümü)",
  CASH_REG_SENDATA_CUSTOMER_CHANGE: "Pos Kasalara Cari Gönder (Değişenler)",

  /* Aylar */
  JANUARY: "Ocak",
  FEBRUARY: "Şubat",
  MARCH: "Mart",
  APRIL: "Nisan",
  MAY: "Mayıs",
  JUNE: "Haziran",
  JULY: "Temmuz",
  AUGUST: "Ağustos",
  SEPTEMBER: "Eylül",
  OCTOBER: "Ekim",
  NOVEMBER: "Kasım",
  DECEMBER: "Aralık",

  /* Haftanin gunleri */
  MONDAY: "Pazartesi",
  TUESDAY: "Salı",
  WEDNESDAY: "Çarşamba",
  THURSDAY: "Perşembe",
  FRIDAY: "Cuma",
  SATURDAY: "Cumartesi",
  SUNDAY: "Pazar",

  /* Cron Expression Type */
  MINUTES: "Dakika",
  HOURLY: "Saatlik",
  HOURLY_EVERY: "Her Saat",
  DAILY: "Günlük",
  WEEKLY: "Haftalık",
  MONTHLY: "Aylık",
  YEARLY: "Yıllık",

  /* Order Type */
  FIRST: "Birinci",
  SECOND: "İkinci",
  THIRD: "Üçüncü",
  FOURTH: "Dördüncü",

  SEND_DATA_MATERIAL: "Malzeme Bilgileri",
  SEND_DATA_CUSTOMER: "Müşteri Bilgileri",
  SEND_DATA_PLU: "Plu Tuş Bilgileri",
  SEND_DATA_SCORE: "Puan Bilgileri",
  SEND_DATA_PROMOTION: "Promosyon Bilgileri",
  SEND_DATA_EXCHANGE_RATE: "Döviz Kur Bilgileri",
  SEND_DATA_PROGRAM_INFO: "Program Ayarları",
  SEND_DATA_CASHIER_SALES_PERSON: "Kasiyer / Satıcı Bilgileri",

  klmpos_message_0: "Mesaj gönderilemedi",
  klmpos_message_1: "Mesaj gönderildi",
  klmpos_message_2: "Kasa bilgileri alıyor",
  klmpos_message_3: "Kasa bilgileri aldı",
  klmpos_message_4: "Kasa bilgileri alamadı",

  /* Messages */
  approved_fiches_cannot_be_changed: "Onaylanmış fişler değiştirilemez",
  approved_fiches_cannot_be_deleted: "Onaylanmış fişler silinemez",
  invoiced_dispatches_cannot_be_changed:
    "Faturası kesilmiş irsaliyeler değiştirilemez",
  invoiced_dispatches_cannot_be_deleted:
    "Faturası kesilmiş irsaliyeler silinemez",
  login_error: "Bir sorun oluştu lütfen tekrar deneyiniz",
  do_filter: "Lütfen filtreleme yapınız",
  could_not_connect_server: "Sunucuya bağlanılamadı.",
  error_data: "Hatalı Veri.",
  important_area: "Bu alanın doldurulması gereklidir",
  code_must_added: "Kod girilmesi gereklidir",
  bad_credentials: "Hatalı kullanıcı adı ya da şifre",
  could_not_login: "Giriş yapılamadı",
  untitled_error: "Bilinmeyen bir hata meydana geldi.",
  processing_is_working: "İşleminiz yapılıyor",
  saving: "Kaydediliyor",
  deleting: "Siliniyor",
  wrong_mail_address_type: "Mail adresi yanlıştır",
  test_mail_send_success_message: "Test Maili Başarılı",
  test_mail_send_error_message: "Test Maili Başarısız",
  current_account_is_closed_to_use: "Cari kullanıma kapalıdır",
  success: "Başarılı",
  success_message: "İşleminiz başarıyla gerçekleştirilmiştir",
  password_set_error: "Şifre oluşturulurken Hata oluştu",
  password_reset_error: "Şifre Sıfırlanırken Hata oluştu",
  password_not_same: "Şifreler eşleşmiyor",
  send_reset_link_success_message:
    "Belirtmiş olduğunuz e-posta adresine şifre sıfırlama yönergelerini içeren mail gönderilmiştir. Lütfen mail kutunuzu kontrol ediniz.",
  reset_password_success_message:
    "Şifreniz başarılı bir şekilde sıfırlanmıştır",
  set_new_password_success_message:
    "Şifreniz başarılı bir şekilde kaydedilmiştir",
  password_change_success_message:
    "Şifreniz başarılı bir şekilde değiştirilmiştir",
  user_create_send_mail:
    " e-posta adresine şifre oluşturma linki gönderilmiştir",
  user_role_required: "Kullanıcı rölü girilmelidir",
  not_access_token_error: "Erişim İzniniz Bulunamadı!",
  end_date_cannot_be_less_than_start_date:
    "Bitiş tarihi başlangıç tarihinden küçük olamaz",
  last_date_cannot_be_less_than_first_date:
    "Son tarih ilk tarihden küçük olamaz",
  target_branches_must_not_empty: "Hedef Şubeler Boş Olamaz",
  tooltip: "Bu kaydı seçerek hızlı işlem gerçekleştirebilirsiniz.",
  warehouse_can_not_be_same: "Giriş ve çıkış depoları aynı olamaz.",
  cash_account_can_not_be_same: "Giriş ve çıkış kasaları aynı olamaz.",
  company_or_period_not_set: "Şirket veya Çalışma dönemi doğru set edilmemiş",
  current_account_type_not_valid: "Cari Hesap türü uygun değil",
  product_is_closed_to_use: "Ürün kullanıma kapalıdır",
  product_is_closed_to_purchasable: "Ürün satınalmaya kapalı",
  current_account_is_closed_to_purchasable: "Cari Hesap satınalmaya kapalı",
  product_is_closed_to_saleable: "Ürün satışa kapalı",
  current_account_is_closed_to_saleable: "Cari Hesap satışa kapalı",
  product_added: "Ürün eklendi",
  product_not_found: "Ürün bulunamadı",
  required_fields_must_be_entered: "Zorunlu Alanlar Girilmelidir",
  material_not_found: "Ürün bulunamadı",
  material_has_set: "Ürün daha önce eklendi",
  debit_and_credit_must_equals: "Borç ve alacak toplamları eşit olmalıdır",
  debit_and_credit_not_equals: "Borç ve alacak toplamları eşit değil",
  branch_not_found: "Şube bulunamadı.",
  not_match_length: "Girilen değer uzunluk alanından büyük olamaz",
  cant_blank_length: "Uzunluk boş bırakılamaz",
  error_message: "Hata Mesajı",
  cash_register_send_data_warning_message:
    "Kasalara bilgi gönderilecektir, devam etmek istiyor musunuz?",
  service_start_has_success: "Servis başlatıldı",
  service_stop_has_success: "Servis durduruldu",
  service_restart_has_success: "Servis yeniden başlatıldı",
  cash_register_sales_retrieving: "Pos kasa satışları çekiliyor",
  cash_register_sales_will_be_withdrawn_message:
    "Pos kasa satışları çekilecektir, Devam etmek istiyor musunuz?",

  /* Toolbar / Grid /Genel */
  create: "Oluştur",
  new: "Yeni",
  copy: "Kopyala",
  edit: "Güncelle",
  view: "İncele",
  approve: "Onayla",
  delete: "Sil",
  rename: "Yeniden Adlandır",
  do_yes: "Evet",
  do_no: "Hayır",
  do_reset: "Temizle",
  continue: "Devam Et",
  go_back: "Geri",
  exit: "Çıkış",
  remove: "Çıkar",
  previous: "Geri",
  next: "İleri",
  save: "Kaydet",
  save_and_new: "Kaydet ve Yeni",
  save_and_close: "Kaydet ve Kapat",
  print: "Yazdır",
  close: "Kapat",
  cancel: "Vazgeç",
  ok: "Tamam",
  apply: "Uygula",
  add: "Ekle",
  refresh: "Yenile",
  all_of: "Hepsini",
  check_all: "Hepsini Seç",
  uncheck_all: "Hepsini Kaldır",
  do_list: "Listele",
  list: "Liste",
  lists: "Listeler",
  export: "Dışa Aktar",
  excel_export: "Excel olarak",
  pdf_export: "PDF olarak",
  other: "Diger",
  column_add_or_remove: "Kolon Ekle / Kaldır",
  field_add_or_remove: "Alan Ekle / Kaldır",
  sending_data: "Bilgiler Gönderiliyor",
  reading_messages: "Mesajlar Okunuyor",
  loading: "Yükleniyor",
  grid_design: "Grid Tasarımı",
  page: "Sayfa",
  design: "Tasarım",
  design_name: "Tasarım Adı",
  template_list: "Tasarım Listesi",
  design_list: "Tasarım Listesi",
  new_design: "Yeni Tasarım",
  save_design: "Tasarımı Kaydet",
  save_design_or_load: "Tasarımı Kaydet/Yükle",
  saved_designs: "Kayıtlı Tasarımlar",
  save_new_design: "Yeni tasarım olarak kaydet",
  edit_design: "Tasarımı Düzenle",
  default_design: "Varsayılan Tasarım",
  save_as_default: "Öndeğer olarak kaydet",
  add_new_line: "Yeni Satır Ekle",
  add_line: "Satır Ekle",
  line_num: "Satır No",
  add_new_line_or_delete: "Yeni Satır Ekle / Sil",
  select: "Seç",
  selected: "Seçilmiştir",
  items_selected: "Seçilenler",
  all: "Tümü",
  new_record: "Yeni Kayıt",
  edit_record: "Güncelleme",
  error: "Hata!",
  excel: "Excel",
  pdf: "Pdf",
  not_found: "Bulunamadı",
  in_out: "Giriş / Çıkış",
  search_value: "Aranacak Değer",
  search: "Ara",
  billing_to: "Faturalaştır",
  EQ: "Eşit",
  NOT_EQ: "Eşit değil",
  GT: "Büyük",
  GE: "Büyük eşit",
  LT: "Küçük",
  LE: "Küçük eşit",
  LIKE: "Benzer",
  NOT_LIKE: "Benzer değil",
  START_WITH: "İle başlar",
  END_WITH: "İle biter",
  IN: "İçeren",
  NOT_IN: "İçermez",
  BETWEEN: "Arasında",
  expression_eq: "Eşittir",
  expression_between: "Arasında",
  expression_in: "İçinde",
  detail_filter: "Detaylı Filtre",
  details: "Detaylar",
  new_filter: "Yeni Filtre",
  create_new_design: "Yeni tasarım oluştur",
  filter_edit: "Filtre Güncelle",
  filter: "Filtre",
  filters: "Filtreler",
  saved_filters: "Kayıtlı Filtreler",
  edit_active_filter: "Aktif filtreyi güncelle",
  filter_values: "Filtre Değerleri",
  filter_name: "Filtre Adı",
  field_list: "Alan Listesi",
  select_lang: "Dil seçiniz",
  select_all: "Tümünü seç",
  un_select_all: "Tümünü kaldır",
  view_source: "Kaynağı görüntüle",
  value: "Değer",
  value1: "Değer 1",
  default_language: "Varsayılan Dil",
  language: "Dil",
  username: "Kullanıcı adı",
  forgot_pass: "Şifremi unuttum",
  signin: "OTURUM AÇ",
  login: "Giriş",
  logout: "Çıkış yap",
  welcome_message: "Karşılama Mesajı",
  good_bye_message: "Uğurlama Mesajı",
  download_message_content: "Mesaj İçeriğini İndir",
  send_file: "Dosya Gönder",
  delete_message: "Mesajı Sil",
  invoice_status: "Fatura Durumu",
  profile: "Profil",
  password: "Şifre",
  current_password: "Mevcut Şifre",
  new_password: "Yeni Şifre",
  new_password_confirmation: "Yeni Şifre Tekrarı",
  set_password: "Şifre oluştur",
  reset_password: "Şifreyi sıfırla",
  reset_my_password: "Şifre mi sıfırla",
  new_user: "Yeni Kullanıcı İsteği",
  help_center: "Yardım Merkezi",
  lines: "Satırlar",
  line: "Satır",
  first_line: "1. Satır",
  second_line: "2. Satır",
  status: "Durumu",
  type: "Türü",
  model: "Modeli",
  INVOICED: "Faturalanmış",
  NOTINVOICED: "Faturalanmamış",
  FIXED: "Sabit",
  INCREMENTAL: "Artan",
  GROUPEDINCREMENTAL: "Gruplanmış Artırımlı",
  BRANCHNO: "Şube No",
  WAREHOUSENO: "Depo No",
  USERCODE: "Kullanıcı Kodu",
  SERVICEPURCHASE: "Alınan Hizmet",
  SERVICESALES: "Verilen Hizmet",
  YEAR: "Yıl",
  MONTH: "Ay",
  WEEK: "Hafta",
  DAY: "Gün",
  HOURS: "Saat",
  COMPANY: "Şirket",
  SUBCOMPANY: "Alt Şirket",
  ROLE_ADMIN: "Admin",
  ROLE_SUPERVISOR: "Supervisor",
  ROLE_USER: "Kullanıcı",
  ROLE_GUEST: "Misafir",
  TRANSFERRER_BALANCE: "Devreden bakiye",
  debit: "Borç",
  credit: "Alacak",
  debit_credit: "Borç / Alacak",
  local_debit: "Yerel Borç",
  local_credit: "Yerel Alacak",
  unselected: "Seçilmemiş",
  add_shipping_address: "Sevkiyat Adresi Ekle",
  shipping_address: "Sevkiyat Adresleri",
  add_invoice_address: "Fatura Adresi Ekle",
  document_num: "Belge No",
  document_special_code: "Belge Özel Kodu",
  external_document_num: "Harici Belge No",
  current_account_name: "Cari Hesap Ünvanı",
  current_account_specode: "Cari Özel Kod",
  current_account_specode2: "Cari Özel Kod2",
  current_account_specode3: "Cari Özel Kod3",
  current_account_specode4: "Cari Özel Kod4",
  current_account_user: "Kayıt Yapan Kullanıcı",
  current_account_receipts: "Cari Hesap Fişleri",
  current_account_receipt: "Cari Hesap Fişi",
  current_account_reports: "Cari Hesap Raporları",
  current_account_extract: "Cari Hesap Ekstresi",
  current_account_balance_report: "Cari Hesap Bakiye Raporu",
  current_account_list_report: "Cari Hesap Liste Raporu",
  current_account_list: "Cari Hesap Listesi",
  last_transaction_date: "Son Hareket Tarihi",
  avarage_due_date: "Ortalama Vade Tarihi",
  due_date: "Vade Gün",
  processes: "İşlemler",
  process: "İşlem",
  messages: "Mesajlar",
  message: "Mesaj",
  exchange_rate: "Kur",
  exchange: "Döviz",
  warning: "Uyarı",
  warnings: "Uyarılar",
  surname: "Soyadı",
  name: "Adı",
  fullname: "Tam Adı",
  title: "Ünvanı",
  father_name: "Baba Adı",
  mother_name: "Anne Adı",
  birth_date: "Doğum Tarihi",
  birth_place: "Doğum Yeri",
  register_num: "Sicil No",
  identity_num: "Kimlik Numarası",
  gender: "Cinsiyet",
  nationality: "Uyruğu",
  religion: "Dini",
  marital_status: "Medeni Durumu",
  single: "Bekar",
  married: "Evli",
  separated: "Ayrılmış",
  divorced: "Boşanmış",
  widowed: "Dul",
  blood_group: "Kan Grubu",
  o_positive: "O Rh+",
  o_negative: "O Rh-",
  a_positive: "A Rh+",
  a_negative: "A Rh-",
  ab_positive: "AB Rh+",
  ab_negative: "AB Rh-",
  b_positive: "B Rh+",
  b_negative: "B Rh-",
  registered_population: "Nüfusa Kayıtlı Olduğu",
  person_id: "Kimliğin",
  volume_num: "Cilt No",
  family_num: "Aile Sıra No",
  sequence_num: "Sıra No",
  serial_num: "Seri No",
  serial_lot_description: "Seri/Lot Açıklama",
  serial_lot_num: "Seri/Lot No",
  serial_lot_transactions: "Seri/Lot Giriş Hareketleri",
  serial_lot_transaction: "Seri/Lot Giriş Hareketi",
  serial_lot_list: "Seri/Lot Listesi",
  transaction: "Hareket",
  transactions: "Hareketler",
  registration_num: "Kayıt No",
  given_place: "Verildiği Yer",
  given_date: "Verildiği Tarih",
  male: "Erkek",
  female: "Kadın",
  bank: "Banka",
  banks: "Bankalar",
  bank_cards: "Bankalar",
  bank_account_num: "Banka Hesap Numarası",
  bank_name: "Banka Adı",
  bank_code: "Banka Kodu",
  bank_account_code: "Banka Hesap Kodu",
  bank_account_name: "Banka Adı",
  account_num: "Hesap Numarası",
  account_number: "Hesap Numarası",
  account_type: "Hesap Türü",
  account_name: "Hesap Adı",
  account_code: "Hesap Kodu",
  bank_branch: "Banka Şubesi",
  iban_num: "İban Numarası",
  iban: "İban",
  row_num: "Sıra No",
  card_num: "Kart No",
  group_code: "Grup Kodu",
  number: "No",
  description: "Açıklama",
  branch: "Şube",
  dest_branch: "Karşı Şube",
  target_branch: "Hedef Şube",
  dest_branch_number: "Karşı Şube No",
  dest_warehouse_number: "Karşı Depo No",
  branch_name: "Şube Adı",
  brand: "Marka",
  brand_code: "Marka Kodu",
  brand_description: "Marka Açıklaması",
  bulk_material_import: "Toplu Malzeme Aktar",
  import_materials: "Malzemeleri Aktar",
  total_data_length: "Toplam kayıt sayısı",
  selected_data_length: "Seçili kayıt sayısı",
  materialSpecode: "Malzeme Özel Kodu",
  specode_description: "Özel Kod Açıklaması",
  specode_code: "Özel Kod Kodu",
  specode_type: "Özel Kod Türü",
  material_special_code: "Malzeme Özel Kodu",
  material_special_code2: "Malzeme Özel Kodu 2",
  material_special_code3: "Malzeme Özel Kodu 3",
  material_special_code4: "Malzeme Özel Kodu 4",
  current_ccount_specode: "Cari Hesap Özel Kodu",
  bank_accounts: "Banka Hesapları",
  bank_account: "Banka Hesabı",
  specode: "Özel Kod",
  special_code: "Özel Kod",
  special_code2: "Özel Kod 2",
  special_code3: "Özel Kod 3",
  special_code4: "Özel Kod 4",
  special_code5: "Özel Kod 5",
  code: "Kodu",
  company: "Şirket",
  companies: "Şirketler",
  companies_and_branches: "Şirketler ve Şubeler",
  company_and_branches: "Şirket ve Şubeler",
  input_quantity: "Giriş Miktarı",
  quantity: "Miktar",
  quantity_divisor: "Miktar Böleni",
  weight: "Gramaj",
  remaining_quantity: "Kalan Miktar",
  price: "Fiyat",
  price_history: "Fiyat Tarihçesi",
  unit_price: "Birim Fiyatı",
  local_price: "Yerel Fiyatı",
  cost: "Masraf",
  tax_num: "Vergi No",
  tax_office: "Vergi Dairesi",
  address: "Adres",
  home_phone: "Ev Telefonu",
  mobile_phone: "Cep Telefonu",
  mobile_phone2: "Cep Telefonu 2",
  phone: "Telefon",
  phone2: "Telefon 2",
  fax_num: "Faks Numarası",
  email_address: "Mail Adresi",
  e_mail: "E-Posta Adresi",
  email: "Mail Adresi",
  send_test_mail: "Test Maili Gönder",
  subject: "Konu",
  receiver: "Alıcı",
  to_whom: "Kime",
  text: "Metin",
  company_email: "Şirket Maili",
  company_phone: "Şirket Telefonu",
  internal_phone: "Dahili No",
  web_address: "Web Adresi",
  trade_register_num: "Ticaret Sicil No",
  mersis_num: "Mersis No",
  web_service_address: "Web Servis Adresi",
  database_name: "Veritabanı Adı",
  server_name: "Sunucu Adı",
  port: "Port",
  use_ssl: "SSL Kullan",
  company_num: "Firma No",
  period_num: "Dönem No",
  branch_num: "Şube No",
  warehouse_balance: "Depo Bakiyesi",
  warehouse_balances: "Depo Bakiyeleri",
  branch_price: "Şube Fiyatı",
  branch_prices: "Şube Fiyatları",
  branch_code: "Şube Kodu",
  branch_description: "Şube Adı",
  warehouse_num: "Depo No",
  picture: "Resim",
  pictures: "Resimler",
  country: "Ülke",
  region: "Bölge",
  territory: "Bölge",
  sales_territory: "Satış Bölgesi",
  sales_territories: "Satış Bölgeleri",
  state: "Eyalet",
  branch_region: "Bölge",
  city: "İl",
  town: "İlçe",
  village: "Köy / Kasaba",
  county: "İlçe",
  sector: "Sektör",
  day: "Gün",
  week: "Hafta",
  date: "Tarih",
  time: "Saat",
  month: "Ay",
  year: "Yıl",
  expiration_date: "Son Kullanma Tarihi",
  exp_date: "Son Kul. Tarihi",
  created_date: "Oluşturulma Tarihi",
  begin_date: "Başlangıç Tarihi",
  end_date: "Bitiş Tarihi",
  active_period: "Aktif Dönem",
  working_period: "Çalışma Dönemi",
  active_working_period: "Aktif Çalışma Dönemi",
  entry_info: "Kayıt Bilgisi",
  entry_must_be_delete: "Kayıt Silinecektir",
  filter_count: "Sayı",
  short_name: "Kısa adı",
  short_description: "Kısa Açıklama",
  un_purchasable: "Satınalma Yapılamaz",
  un_purchasable_order: "Satınalma Siparişi Açılamaz",
  tracking_method: "Seri/Lot",
  category: "Kategori",
  shelf_life: "Raf ömrü",
  plu_num: "Plu No",
  producer_material_code: "Üretici Malzeme Kodu",
  purchase_vat_group: "Alış KDV %",
  sales_vat_group: "Satış KDV %",
  purchase_currency: "Alış Döviz Türü",
  purchase_exchange_rate: "Alış Döviz Kuru",
  purchase_price: "Alış Fiyatı",
  purchase_price_local: "Yerel Alış Fiyatı",
  net_purchase_price: "Net Alış Fiyatı",
  net_purchase_price_local: "Yerel Net Alış Fiyatı",
  list_price: "Liste Fiyatı",
  diff_vat_rate: "KDV Fark %",
  diff_vat_amount: "KDV Fark Tutar",
  diff_vat_amount_local: "Yerel KDV Fark Tutar",
  cost_price: "Maliyet Fiyatı",
  cost_price_local: "Yerel Maliyet Fiyatı",
  list_price_local: "Yerel Liste Fiyatı",
  profit_margin: "Kar Marjı",
  sales_currency: "Satış Döviz Türü",
  sales_currency_code: "Satış Döviz Kodu",
  sales_exchange_rate: "Satış Döviz Kuru",
  total_profit_price: "Toplam Kar Tutarı",
  total_sales_price: "Toplam Satış Tutarı",
  total_cost_price: "Toplam Maliyet Tutarı",
  new_sales_price: "Yeni Satış Fiyatı",
  sales_price: "Satış Fiyatı",
  new_sales_price_local: "Yerel Yeni Satış Fiyatı",
  last_label_print_date: "Son Etiket Basım Tarihi",
  sales_price_local: "Yerel Satış Fiyatı",
  active_sales_price: "Mevcut Satış Fiyatı",
  active_sales_price_local: "Yerel Mevcut Satış Fiyatı",
  risk_limit_amount: "Risk Limit Tutarı",
  discount_rate: "İskonto %",
  expense_rate: "Masraf %",
  discount_amount: "İskonto Tutarı",
  expense_amount: "Masraf Tutarı",
  origin: "Menşei",
  barcodes: "Barkodlar",
  material_responsibility: "Ürün Sorumluları",
  barcode: "Barkod",
  connection_type: "Bağlantı Türü",
  barcode_type: "Barkod Türü",
  unit_type: "Birimi",
  payment_type: "Ödeme Tipi",
  product_manager: "Ürün Sorumlusu",
  unit_sets: "Birim Setleri",
  unit_set_code: "Birim Seti Kodu",
  unit_code: "Birim Kodu",
  multiplier: "Çarpan",
  sales_information: "Satış Bilgileri",
  purchase_information: "Satın Alma Bilgileri",
  un_saleable: "Satış Yapılamaz",
  un_salable: "Satış Yapılamaz",
  un_saleable_order: "Satış Siparişi Açılamaz",
  un_salable_order: "Satış Siparişi Açılamaz",
  un_transferable: "Transfer Edilemez",
  sales_unit: "Satış Birimi",
  purchase_unit: "Satınalma Birimi",
  un_purchaseable: "Satınalma Yapılamaz",
  un_purchaseable_order: "Satınalma Siparişi Verilemez",
  unit_name: "Birim Adı",
  shortName: "Kısa Adı",
  related_companies: "İlişkili Şirketler",
  related_branches: "İlişkili Şubeler",
  overview: "Genel Bakış",
  erp_menu: "ERP Menü",
  admin_menu: "Yönetim Menü",
  favorites: "Sık Kullanılanlar",
  main_records: "Ana Kayıtlar",
  sales_personal: "Satıcılar",
  sales_person_code: "Satış Elemanı Kodu",
  employees: "Çalışanlar",
  employee: "Çalışan",
  material_management: "Malzeme Yönetimi",
  current_account_item_code: "Tedarikçi Malzeme Kodu",
  service_cards: "Hizmet Kartları",
  service_card: "Hizmet Kartı",
  suppliers: "Tedarikçiler",
  purchase_management: "Satınalma",
  dispatch_date: "İrsaliye Tarihi",
  invoice_date: "Fatura Tarihi",
  dispatch_first_date: "İrsaliye İlk Tarih",
  invoice_first_date: "Fatura İlk Tarih",
  dispatch_last_date: "İrsaliye Son Tarih",
  invoice_last_date: "Fatura Son Tarih",
  dispatch_num: "İrsaliye No",
  invoice_num: "Fatura No",
  receipt_num: "Fiş No",
  fiche_limit: "Fiş Limit",
  fiche_header_info: "Fiş Başlık Bilgileri",
  fiche_end_info: "Fiş Sonu Bilgileri",
  dispatches: "İrsaliyeler",
  purchase_dispatch: "Satınalma İrsaliyesi",
  purchase_dispatches: "Satınalma İrsaliyeleri",
  purchase_invoice: "Satınalma Faturası",
  purchase_invoices: "Satınalma Faturaları",
  sales_dispatch: "Satış İrsaliyesi",
  sales_dispatches: "Satış İrsaliyeleri",
  sales_invoice: "Satış Faturası",
  sales_invoices: "Satış Faturaları",
  invoices: "Faturalar",
  buying_management: "Satınalma Yönetimi",
  sales_management: "Satış Yönetimi",
  sales: "Satış",
  finance_management: "Finans Yönetimi",
  crm_management: "CRM",
  retail_management: "Perakende Yönetimi",
  it_management: "BT Yönetimi",
  app_management: "Uygulama Parametreleri",
  dispatchInfo: "İrsaliye Bilgileri",
  finance: "Finans",
  definitions: "Tanımlar",
  materials: "Malzemeler",
  company_based_materials: "Şirket Bazında Malzemeler",
  material_definitions: "Malzeme Tanımları",
  cards: "Kartlar",
  sales_person: "Satış Elemanları",
  units: "Birimler",
  unit: "Birim",
  master_unit: "Ana Birim",
  master_units: "Ana Birimler",
  unit_set: "Birim Setleri",
  unit_set_units: "Birim Set Birimleri",
  movements: "Hareketler",
  reports: "Raporlar",
  report: "Rapor",
  extracts: "Ekstreler",
  flag: "Bayrak",
  extract: "Ekstre",
  brands: "Markalar",
  user_roles: "Kullanıcı Rolleri",
  users: "Kullanıcılar",
  user: "Kullanıcı",
  recording_user: "Kayıt Yapan Kullanıcı",
  role_permission: "Rol Yetkisi",
  role_permissions: "Rol Yetkileri",
  all_user: "Tüm Kullanıcılar",
  active_user: "Aktif Kullanıcı",
  valid_for_all_users: "Tüm kullanıcılar için geçerli",
  user_role: "Kullanıcı Rolü",
  role_name: "Rol Adı",
  password_expired: "Parola Bitiş Tarihi",
  rayons: "Reyonlar",
  rayon: "Reyon",
  rayon_code: "Reyon Kodu",
  rayon_description: "Reyon Açıklaması",
  special_codes: "Özel Kodlar",
  current_account: "Cari Hesap",
  customers: "Müşteriler",
  customer: "Müşteri",
  customer_list_report: "Müşteri Liste Raporu",
  balance: "Bakiye",
  isprivate_company: "Şahıs Şirketi",
  general: "Genel",
  connection_information: "Bağlantı Bilgileri",
  general_information: "Genel Bilgiler",
  retail_information: "Perakende Bilgileri",
  amount_information: "Tutar Bilgileri",
  account_information: "Hesap Bilgileri",
  fiche_information: "Fiş Bilgileri",
  identity_information: "Kimlik Bilgileri",
  in_detail_information: "Detay Bilgileri",
  in_vat_information: "Vergi Oranları",
  contact_information: "İletişim Bilgileri",
  address_information: "Adres Bilgileri",
  other_information: "Diğer Bilgiler",
  commercial_information: "Ticari Bilgiler",
  params: "Parametreler",
  total: "Toplam",
  net_total: "Net Toplam",
  discount: "İndirim",
  vat: "KDV",
  vat_amount: "KDV Tutarı",
  vat_group: "KDV Grubu",
  vat_groups: "KDV Grupları",
  vat_group_name: "KDV Grup Adı",
  vat_rates: "KDV Oranları",
  vat_rate: "KDV oranları",
  vat_included: "KDV (D/H)",
  purch_vat_rate: "Alış KDV Oranı",
  sales_vat_rate: "Satış KDV Oranı",
  persale_vat_rate: "Perakende Satış KDV Oranı",
  persale_department: "Perakende Satış Departmanı",
  sales_department: "Topdan Satış Departmanı",
  working_periods: "Çalışma Dönemleri",
  workingPeriod: "Çalışma Dönemi",
  set_active_working_period: "Çalışma dönemi olarak işaterle",
  need_set_active_working_period:
    "Çalışma dönemi olarak işaretlemek istiyormusun ?",
  added: "Ekleyen",
  last_changed: "Son Değiştiren",
  changes: "Değişenler",
  sectors: "Sektörler",
  branches: "Şubeler",
  branch_list: "Şube Listesi",
  regions: "Bölgeler",
  warehouses: "Depolar",
  payment_plans: "Ödeme Planları",
  payment_plan: "Ödeme Planı",
  warehouse: "Depo",
  dest_warehouse: "Karşı Depo",
  email_settings: "E-Mail Ayarları",
  company_settings: "Şirket Ayarları",
  number_series: "Numara Serileri",
  vouchers: "Fişler",
  required_fields: "Zorunlu Alanlar",
  send_report: "Rapor Gönder",
  table_or_pivot_or_excel: "Tablo / Pivot / Excel",
  list_report: "Liste Raporu",
  matrix_report_compact: "Matris Raporu (Compact)",
  matrix_report_classic: "Matris Raporu (Classic)",
  excel_report: "Excel Raporu",
  monitor_report: "Ekran Raporu",
  report_name: "Rapor Adı",
  bank_codes: "Banka Kodları",
  tax_houses: "Vergi Daireleri",
  customer_card: "Müşteri Kartı",
  customer_code: "Müşteri Kodu",
  customer_status: "Müşteri Durumu",
  customer_type: "Müşteri Türü",
  customer_name: "Müşteri Adı",
  customer_surname: "Müşteri Soyadı",
  current_accounts: "Cari Hesaplar",
  current_account_not_set: "Cari hesap seçilmemiştir",
  current_account_transaction: "Cari Hesap Hareketi",
  current_account_transactions: "Cari Hesap Hareketleri",
  material: "Malzeme",
  material_transaction: "Malzeme Haraketi",
  not_seen_transaction: "Haraket Görmeyenler",
  material_transactions: "Malzeme Haraketleri",
  material_management_receipt: "Malzeme Yönetim Fişi",
  material_management_receipts: "Malzeme Yönetim Fişleri",
  company_based_material: "Şirket Bazında Malzeme",
  currency_type: "Döviz Türü",
  line_type: "Türü",
  main_current_account: "Ana Cari",
  rate_calc_type: "Kur Türü",
  rate: "Oran",
  number_schema: "Numaralama Şablonları",
  approval_status: "Onay Durumu",
  approval_date: "Onay Tarihi",
  approved_branches: "Onaylayan Şubeler",
  approval_user: "Onaylayan Kullanıcı",
  approval: "Onaylı",
  document_type: "Belge Türü",
  document_date: "Belge Tarihi",
  document_time: "Belge Saati",
  last_num: "Son Numara",
  amount: "Tutar",
  local_amount: "Yerel Tutar",
  total_amount: "Tutar",
  local_total_amount: "Yerel Tutar",
  net_total_amount: "Toplam Tutar",
  gross_total_amount: "Tutar",
  number_schema_detail: "Numaralandırma Detayı",
  length: "Uzunluk Sayısı",
  property: "Özellik",
  start_num: "Başlangıç Numarası",
  end_num: "Bitiş Numarası",
  select_first_company: "Şirket seçiniz.",
  select_and_continue: "Seç ve Yeni Satır",
  number_scheme_detail: "Numaralama Detayı",
  numberscheme: "Numaralama Şablonu",
  scales: "Terazi İlişkilendirme",
  scale_type: "Terazi İlişkilendirme",

  material_status: "Malzeme Durumu",
  material_status_report: "Malzeme Durum Raporu",
  material_balance_type: "Malzeme Bakiye Türü",
  material_barcode: "Malzeme Barkodu",
  material_type: "Malzeme Tipi",
  material_code: "Malzeme Kodu",
  material_description: "Malzeme Açıklaması",
  material_specode: "Malzeme Özel Kod",
  material_specode2: "Malzeme Özel Kod 2",
  material_specode3: "Malzeme Özel Kod 3",
  material_specode4: "Malzeme Özel Kod 4",
  material_specode5: "Malzeme Özel Kod 5",
  material_user: "Kayıt Yapan Kullanıcı",
  specode_user: "Kayıt Yapan Kullanıcı",
  record_date: "Kayıt Tarihi",
  first_record_date: "İlk Kayıt Tarihi",
  first_date: "İlk Tarih",
  last_record_date: "Son Kayıt Tarihi",
  last_date: "Son Tarih",
  last_changed_user: "Son Değiştiren Kullanıcı",
  first_date_changed: "İlk Değiştirme Tarihi",
  last_date_changed: "Son Değiştirme Tarihi",
  cashier: "Kasiyer",
  cashiers: "Kasiyerler",
  groups: "Gruplar",
  material_with_group: "Gruba bağlı malzemeler",
  cashier_name: "Kasiyer Adı",
  payment_with_credit_card: "Kredi Kartlı Ödeme",
  payment_with_currency: "Dövizli Ödeme",
  meal_ticket: "Yemek Fişi",
  pos_cash_stock_code: "Pos Kasa Stok Kodu",
  pos_material_code: "Pos Kasa Stok Kodu",
  cash_register_model: "Kasa Modeli",
  cash_register_closed_message: "Kasa Kapalı Mesajı",
  auth_num: "Yetki No",
  auth_description: "Yetki Açıklaması",
  authorisation_group: "Yetki Grubu",
  authorisation_groups: "Yetki Grubları",
  cashier_authorisation_groups: "Kasiyer Yetki Grubları",
  max_disc_rate: "Maksimum İndirim Oranı",
  max_disc_amount: "Maksimum İndirim Tutarı",
  cash_accounts: "Kasa Hesapları",
  cash_register_code: "Pos Kasa Kodu",
  cash_register_description: "Pos Kasa Açıklaması",
  cash_register: "Pos Kasa",
  cash_registers: "Pos Kasalar",
  cash_register_general_definition: "Pos Kasa Genel Tanımları",
  cash_register_department: "Departman Tanımları",
  cash_reg_department: "Departman",
  cash_register_payment_key: "Ödeme Tuşları",
  cash_register_type_based_parameters: "Kasa Modeli Parametreleri",
  cash_register_type_based_parameter: "Kasa Modeli Parametresi",
  kl_retail_mpos_parameters: "KL Retail MPOS Parametreleri",
  kl_retail_mpos: "KL Retail MPOS",
  branch_based_parameters: "Şube Bazında Parametreler",
  branch_based_parameter: "Şube Bazında Parametre",
  material_cards_parameters: "Malzeme Kart Parametreleri",
  material_cards_parameter: "Malzeme Kart Parametresi",
  cash_register_display: "Müşteri Göstergesi",
  cash_register_plu: "Etiket Tuşları",
  cash_register_scales_flag: "Terazi Bayrak Tanımları",
  cash_account_cards: "Kasa Kartları",
  cash_account_card: "Kasa Kartı",
  cash_account: "Kasa Hesabı",
  dest_cash_account: "Karşı Kasa",
  cash_account_num: "Kasa No",
  dest_cash_account_num: "Karşı Kasa No",
  cash_account_description: "Kasa Açıklaması",
  dest_cash_account_description: "Karşı Kasa Açıklaması",
  price_change_receipts: "Fiyat Değişim Fişleri",
  price_change_receipt: "Fiyat Değişim Fişi",
  cash_account_receipts: "Kasa Fişleri",
  cash_account_receipt: "Kasa Fişi",
  cash_account_reports: "Kasa Raporları",
  bank_reports: "Kasa Raporları",
  company_name: "Firma Adı",
  company_number: "Firma No",
  company_description: "Firma Ünvanı",
  working_period_number: "Dönem No",
  working_period_description: "Dönem Adı",
  current_account_code: "Cari Hesap Kodu",
  current_account_description: "Cari Hesap Ünvanı",
  branch_number: "Şube Kodu",
  key_number: "Tuş No",
  warehouse_description: "Depo Adı",
  warehouse_number: "Depo Kodu",
  material_receipt_document_types: "Malzeme Yönetim Belge Türü",
  purchase_document_types: "Satınalma Belge Türü",
  sales_document_types: "Satış Belge Türü",
  line1: "1. Satır",
  line2: "2. Satır",
  line3: "3. Satır",
  line4: "4. Satır",
  line5: "5. Satır",
  line6: "6. Satır",
  line7: "7. Satır",
  line8: "8. Satır",
  round_sales_rice: "Satış Fiyatını Yuvarlama",
  round_type: "Yuvarlama Türü",
  second_after_comma: "Vilgülden Sonra 2 nci basamak",
  unspecified: "Belirtilmemiş",
  upper: "Yukarı",
  lower: "Aşşağı",
  label_print: "Etiket Basımı",
  material_labels: "Malzeme Etiketleri",
  material_label: "Malzeme Etiketi",
  material_label_types: "Malzeme Etiket Türleri",
  material_label_type: "Malzeme Etiket Türü",
  label_type: "Etiket Türü",
  material_group_types: "Malzeme Grup Türleri",
  material_group_type: "Malzeme Grup Türü",
  material_group_hierarchy: "Malzeme Grup Hiyerarşisi",
  group_hierarchy: "Grup Hiyerarşisi",
  hierarchy: "Hiyerarşi",
  label_print_design: "Barkodlu Etiket Tasarımı",
  print_label: "Etiket Yazdır",
  host_name: "Smtp Host Adı",
  send_address: "Gönderen Adresi",
  port_number: "Port No",
  timeout_with_second: "Zaman Aşımı (sn)",
  user_name: "Kullanıcı Adı",
  send_type: "Gönderim Türü",
  cash_register_send_data: "Kasalara Bilgi Gönderimi",
  send_data: "Bilgi Gönder",
  currency_date: "Kur Tarihi",
  price_changed: "Fiyatı Değişenler",
  info_retrieval_date: "Bilgi Alma Tarihi",
  message_check_date: "Mesaj kontrol süresi (sn)",
  last_read_date: "Son Okuma Tarihi",
  dashboard_management: "Pano Yönetimi",
  dashboard: "Pano",
  dashboards: "Panolarım",
  widget_list: "Widget Listesi",
  pending_approval_price_change_receipts: "Onay Bekleyen Fiyat Değişim Fişleri",
  current_user_approval_price_change_receipts:
    "Mevcut kullanıcıya ait onay bekleyen fiyat değişim fişleri",
  add_widget: "Widget Ekle",
  cash_connection_status: "Kasa Bağlantı Durumu",
  last_signal: "Son Veri Okuma",
  schedule_type: "Görev Türü",
  cron_expression_type: "Cron Türü",
  schedule: "Görev Zamanlayıcısı",
  schedules: "Görev Zamanlayıcıları",
  schedule_start_send_email: "Görev Başladığında E-Posta Gönder",
  schedule_end_send_email: "Görev Bittiğinde E-Posta Gönder",
  schedule_start_send_content: "Görev Başladığında Gönderilecek Metin İçeriği",
  schedule_end_send_content: "Görev Bittiğinde Gönderilecek Metin İçeriği",
  email_addresses: "E-Posta Adresleri",
  service_start: "Servisi Başlat",
  service_stop: "Servisi Durdur",
  service_restart: "Servisi Yeniden Başlat",
  process_type: "İşlem Türü",
  select_interval_for_scheduling:
    "Görevin zamanlamaya başlaması için yineleme aralıklarını seçin",
  cash_register_end_of_date: "Gün Sonu İşlemi",
  cash_register_end_of_date_start: "Gün sonu işlemi başlat",
  sales_current_account_code: "Satış Cari Hesap Kodu",
  return_current_account_code: "İade Cari Hesap Kodu",
  dispatch_amount: "İrsaliye Tutarı",
  return_amount: "İade Tutarı",
  z_dispatch_amount2: "Net Satış Tutarı",
  z_amount: "Z Tutarı",
  z_dispatch_amount: "Z Tutarı (İrsaliye)",
  difference_amount: "Z Tutarı (İrsaliye)",
  z_number: "Z No",
  sales_do_invoiced: "Satışları Faturalandır",
  get_sales: "Satışları Çek",
  delete_sales: "Satışları Sil",
};
